var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backdrop",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.closeModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal",class:{ sale: _vm.theme === 'sale'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }